import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { Paged } from "../../../utils/backend-types";
import type { StartPageRegulatoryTodo } from "../StartPage.types";

function useStartPageRegulatoryTodos(
  page: number,
  pageSize: number,
  projectId?: string,
  companyId?: number
) {
  return useQuery({
    queryKey: urls.startPage.regulatoryTodos.key({
      page,
      pageSize,
      projectId,
      companyId
    }),
    queryFn: () =>
      fetchStartPageRegulatoryTodos(page, pageSize, projectId, companyId)
  });
}

async function fetchStartPageRegulatoryTodos(
  page: number,
  pageSize: number,
  projectId?: string,
  companyId?: number
) {
  const response = await apiWithoutCamelization.get<
    Paged<StartPageRegulatoryTodo>
  >(
    urls.startPage.regulatoryTodos.url({ page, pageSize, projectId, companyId })
  );
  return response.data;
}

export { useStartPageRegulatoryTodos };
